App.controller('setupWorkingHoursPopup', ($scope, $rootScope, $api) => {

  $scope.hours = _.range(1, 13).map(num => ('0' + num).slice(-2))
  $scope.minutes = _.range(0, 56, 5).map(num => ('0' + num).slice(-2))
  $scope.meridians_am = 'AM'
  $scope.meridians_pm = 'PM'
  $scope.meridians = [$scope.meridians_am, $scope.meridians_pm]
  $scope.every_numbers = _.range(1, 31, 1)
  $scope.every_units = ['day', 'week', 'month']
  $scope.working_hours_options = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]


  // initialize

  initWorkingHours = () => {
    _.each($scope.working_hours, (wh) => {
      setWorkingHourInitialOptions(wh)
      setWorkingHourIsCheckedOptions(wh)
    })
  }

  setWorkingHourInitialOptions = (wh) => {
    if (!wh.options) {
      wh.options = angular.copy(_.map($scope.working_hours_options, (opt) => {return {'name': opt, 'isChecked': false}}))
    }
  }

  setWorkingHourIsCheckedOptions = (wh) => {
    if(wh.misc && wh.misc.days && wh.misc.days.length){
      _.each(wh.misc.days, (wh_day) => {
        workingHourOptionActivate(wh, wh_day)
      })
    } else {
      setWorkingHourInitialOptions(wh)
      workingHourOptionActivate(wh, wh.day)
    }
  }

  workingHourOptionActivate = (wh, wh_day) => {
    wh_options_weekday = _.filter(wh.options, (opt) => {return opt.name == wh_day})
    if(wh_options_weekday && wh_options_weekday[0]){
      wh_options_weekday[0].isChecked = true
    }
  }

  // `On a specific date` dropdown
  $scope.toggleOnDate = (wh) => {
    if(wh.toggle_on_date){
      wh.toggle_every = false
    } else {
      onDisableToggle(wh)
    }
  }

  $scope.workingHourDateUpdate = (wh, newDate) => {
    newDateMoment = moment(newDate)
    wh.misc.on_date = newDateMoment.format("YYYY-MM-DD")
    delete wh.misc.days
    wh.day = null

    $scope.setWorkingDaysOption(wh, {isChecked: false, name: newDateMoment.format("dddd")}, true)
  }

  // `Custom repeat` dropdown
  $scope.toggleEvery = (wh) => {
    if(wh.toggle_every){
      wh.toggle_on_date = false
    } else {
      onDisableToggle(wh)
    }
  }

  onDisableToggle = (wh) => {
    delete wh.misc.days
    wh.day = null
    setWorkingHourIsCheckedOptions(wh)
    $scope.setWorkingHourLabel(wh)
  }

  $scope.workingHourEveryRefDateUpdate = (wh, newDate) => {
    newDateMoment = moment(newDate)
    if(!wh.misc.every){
      wh.misc.every = {}
    }
    wh.misc.every.ref = newDateMoment.format("YYYY-MM-DD")
  }


  // `From` and `To` dropdowns
  $scope.workingHourMeridianUpdate = (wh, from=true) => {
    if(from){
      meridianUpdate(wh.begin_time_in_tz)
    } else {
      meridianUpdate(wh.end_time_in_tz)
    }
  }

  meridianUpdate = (time) => {
    if(time.meridian == $scope.meridians_am){
      time.meridian = $scope.meridians_pm
    } else {
      time.meridian = $scope.meridians_am
    }
  }

  // check/uncheck day from the dropdown

  $scope.setWorkingDaysOption = (wh, nv, toggle_on_date_enabled=false) => {
    nv.isChecked = !nv.isChecked

    setWorkingDaysOptionForWeekday(wh, nv, toggle_on_date_enabled)
    setWorkingHourIsCheckedOptions(wh)
    $scope.setWorkingHourLabel(wh)
  }

  setWorkingDaysOptionForWeekday = (wh, nv, toggle_on_date_enabled=false) => {
    // single day should be saved in wh.day
    // multiple days should be saved in wh.misc.days while wh.day should be nil
    if(nv.isChecked){
      enableWorkingDaysOptionForWeekday(wh, nv, toggle_on_date_enabled)
    } else {
      disableWorkingDaysOptionForWeekday(wh, nv)
    }
    if(wh.misc.days && wh.misc.days.length > 1){
      wh.misc.days = _.sortBy(wh.misc.days, (misc) => {return $scope.working_hours_options.indexOf(misc)})
    }
  }

  enableWorkingDaysOptionForWeekday = (wh, nv, toggle_on_date_enabled=false) => {
    if(!toggle_on_date_enabled){ // cancel 'on a specific date' section
      wh.toggle_on_date = false
    }
    if(wh.misc.days && wh.misc.days.length && _.includes(wh.misc.days, nv.name)){
      // remain option in a `wh.misc.days`
      wh.day = null
    } else if (wh.misc.days && wh.misc.days.length) {
      wh.misc.days.push(nv.name)
      wh.day = null
    } else if(wh.day == nv.name){
      // remain option in a `wh.day` attr
      delete wh.misc.days
    } else if(wh.day){
      wh.misc.days = [wh.day, nv.name]
      wh.day = null
    } else {
      wh.day = nv.name
    }
  }

  disableWorkingDaysOptionForWeekday = (wh, nv) => {
    if(wh.misc.days && wh.misc.days.length && _.includes(wh.misc.days, nv.name)){
      _.remove(wh.misc.days, (misc) => {return misc == nv.name})
      if(wh.misc.days.length == 1){
        wh.day = wh.misc.days[0]
      }
      if(wh.misc.days.length <= 1){
        delete wh.misc.days
      }
    }
  }


  // save

  $scope.save = () => {
    appointment_types = getSelectedAppointmentTypes()
    _.each($scope.working_hours, (wh) => {
      // copy nested attributes not configured by proxy
      wh.begin_time_in_tz = $scope.wh.begin_time_in_tz
      wh.end_time_in_tz = $scope.wh.end_time_in_tz
      wh.misc = $scope.wh.misc
      setAppointmentTypes(wh, angular.copy(appointment_types))
    })
    $scope.saveWorkingHours($scope.working_hours, () => {
      if (typeof($scope.closeThisDialog) == 'function'){
        $scope.closeThisDialog({ saved: true })
      }
    })
  }


  // operatory

  $scope.hasOperatory = (operatory) => {
    return _.filter($scope.wh.operatories, (op) => op.uuid === operatory.uuid).length > 0
  }

  $scope.setOperatory = (operatory) => {
    if ($scope.hasOperatory(operatory)) {
      removeOperatory(operatory)
    } else {
      addOperatory(operatory)
    }
  }

  removeOperatory = (operatory) => {
    wh = _.find($scope.working_hours, (wh) => wh.operatory && (wh.operatory.uuid === operatory.uuid))
    if (!wh) return

    if (wh.id || $scope.working_hours.length === 1) {
      wh._destroy = true
    } else {
      _.remove($scope.working_hours, (wh) => wh.operatory && (wh.operatory.uuid === operatory.uuid))
    }
  }

  addOperatory = (operatory) => {
    wh = _.find($scope.working_hours, (wh) => wh.operatory && (wh.operatory.uuid === operatory.uuid))
    if (wh) {
      delete wh._destroy
      return
    }

    if ($scope.working_hours.length == 1 && !$scope.working_hours[0].operatory) {
      $scope.working_hours[0].operatory = operatory
      return
    }

    wh = angular.copy($scope.working_hours[0])
    delete wh.id
    delete wh._destroy
    wh.operatory = operatory
    wh.appointment_types = []
    $scope.working_hours.push(wh)
  }

  $scope.getOperatories = () => {
    return _.uniqBy($scope.wh.operatories, 'uuid')
  }

  $scope.activeOperatories = () => {
    return $scope.operatories.filter(op => op.active)
  }


  // appointment types

  $scope.initAppointmentTypes = (data) => {
    $scope.custom_appointment_types = $scope.wh.appointment_types.length > 0

    return _.map(data, (cat) => {
      const appt_type = _.find($scope.wh.appointment_types, (appt_type) => appt_type.appt_category.id === cat.id) || {}
      return {
        id: appt_type.id,
        appt_category_id: cat.id,
        name: appt_type.name || cat.name,
        category: appt_type.category || cat.category,
        minutes: appt_type.minutes || cat.minutes,
        institution_id: appt_type['institution_id'] || $rootScope.institution.id,
        enabled: appt_type['appt_category'] !== undefined
      }
    })
  }

  getSelectedAppointmentTypes = () => {
    appointment_types = _.filter($scope.appointment_types, (appt_type) => ($scope.custom_appointment_types && appt_type.enabled) || appt_type.id)
    if (!appointment_types.length) {
      return []
    }

    appointment_types = _.map(appointment_types, (appt_type) => {
      if ($scope.custom_appointment_types && appt_type.enabled) {
        delete appt_type._destroy
      } else {
        appt_type._destroy = true
      }

      return _.pick(appt_type, 'id', 'institution_id', 'appt_category_id', 'name', 'category', 'minutes', '_destroy')
    })

    return appointment_types
  }

  setAppointmentTypes = (wh, appointment_types) => {
    _.each(appointment_types, (appt_type) => {
      const original_appt_type = _.find(wh.appointment_types, (original_appt_type) => appt_type.appt_category_id === original_appt_type.appt_category.id)
      if (original_appt_type) {
        appt_type.id = original_appt_type.id
      } else {
        delete appt_type.id
      }
    })

    wh.appointment_types_attributes = appointment_types
  }

  $scope.noCustomApptTypes = () => {
    if (!$scope.custom_appointment_types) {
      return false
    }

    appointment_types = _.filter($scope.appointment_types, (appt_type) => appt_type.enabled)
    return appointment_types.length == 0
  }


  // initialize

  if ($scope.ngDialogData && $scope.ngDialogData.title) {
    $scope.title = $scope.ngDialogData.title
    $scope.working_hours = $scope.ngDialogData.working_hours
    $scope.operatories = $scope.location.operatories
    $scope.wh = new Proxy($scope.working_hours[0], {
      get: function (target, prop, receiver) {
        if (prop === 'operatories') {
          has_operatories = _.filter($scope.working_hours, (wh) => !wh._destroy && wh.operatory)
          return _.map(has_operatories, (wh) => wh.operatory)
        }
        return Reflect.get(...arguments);
      },
      set: (target, prop, value) => {
        _.each($scope.working_hours, (wh) => {
          wh[prop] = value
        })
        return true
      }
    })
    initWorkingHours()
    $scope.appointment_types = $scope.initAppointmentTypes($scope.appt_categories)
    $scope.setDisplayNameForOperatories($scope.operatories)
    $scope.setDisplayNameForOperatories($scope.wh.operatories)
  }

  loadAppointmentCategories = () => {
    let page = 1
    $scope.more_appt_categories_loading = true

    // Paginate through API until all AppointmentCategories are loaded.
    // This lets the app correctly render which custom appointment types are enabled.
    const makeCategoryRequest = (page) =>
      $api("GET", "/appointment_categories", {
        page,
        location_id: $rootScope.location.id,
      }).then((resp) => {
        if (resp && resp.data && resp.data.data.length) {
          const dataFormatted = $scope
            .initAppointmentTypes(resp.data.data)
            .filter(Boolean)
          $scope.appointment_types = _.uniqBy(
            $scope.appointment_types.concat(dataFormatted),
            "appt_category_id"
          )
          page += 1
          return makeCategoryRequest(page)
        }
      })

    makeCategoryRequest(page).finally(() => {
      $scope.more_appt_categories_loading = false
    })
  }

  loadAppointmentCategories()
})
